export const logoSvg = "/svgs/logo.svg";
